import styled from "styled-components";
import { VerificationButton } from "../common/VerificationButton";
import CodeInput from "../common/CodeInput";
import { FormField } from "@/shared/components";

const VerificationStep = styled.div`
	display: contents;
`;

const VerificationIntro = styled.div`
	width: 100%;
`;

const CreatorCodeInput = styled.div<{ $invalid: boolean }>`
	width: 100%;

	> div {
		width: 100%;
		gap: 16px;
		justify-content: flex-start;
		margin-bottom: 0;
	}

	.ant-input {
		width: calc((100% - 80px) / 6);
		min-width: 0;
		max-width: none;
		flex: 1 1 0;
		height: 64px;
		padding: 0;
		box-sizing: border-box;
		border: 1px solid ${(props) => (props.$invalid ? "#e43838" : "#dbdbdb")};
		border-radius: 8px;
		box-shadow: ${(props) => (props.$invalid ? "inset 0 0 0 1px #e43838" : "none")};

		&[data-filled="true"],
		&:focus {
			border-color: ${(props) => (props.$invalid ? "#e43838" : "#4460ef")};
			box-shadow: ${(props) =>
				props.$invalid
					? "inset 0 0 0 1px #e43838, 0 0 0 2px rgba(228, 56, 56, 0.1)"
					: "inset 0 0 0 1px #4460ef, 0 4px 12px rgba(21, 89, 165, 0.04)"};
		}
	}
`;

const VerificationActions = styled.div`
	width: 100%;
	margin-top: 24px;
`;

interface RoleRegisterVerificationStepProps {
	error: string;
	loading: boolean;
	resetSignal: number;
	isSuccess: boolean;
	isSubmitting: boolean;
	resendSeconds: number;
	onCodeChange: (code: string) => void;
	onCodeComplete: (code: string) => void;
	onResend: () => void;
}

export const RoleRegisterVerificationStep = ({
	error,
	loading,
	resetSignal,
	isSuccess,
	isSubmitting,
	resendSeconds,
	onCodeChange,
	onCodeComplete,
	onResend,
}: RoleRegisterVerificationStepProps) => {
	const verifying = isSubmitting || isSuccess;

	return (
		<VerificationStep>
			<VerificationIntro>
				<FormField label="Code" error={error}>
					<CreatorCodeInput $invalid={error === "Invalid code"}>
						<CodeInput
							resetSignal={resetSignal}
							onChange={onCodeChange}
							onComplete={onCodeComplete}
							disabled={loading}
							isSuccess={isSuccess}
						/>
					</CreatorCodeInput>
				</FormField>
			</VerificationIntro>

			<VerificationActions>
				<VerificationButton
					type="button"
					idleVariant="primary"
					verifying={verifying}
					disabled={loading || isSuccess || resendSeconds > 0}
					onClick={onResend}
				>
					{resendSeconds > 0 ? `Resend in ${resendSeconds}s` : "Resend code"}
				</VerificationButton>
			</VerificationActions>
		</VerificationStep>
	);
};
